import { useQueryState } from '@ywwwtseng/react-kit';

export function useShareUrl() {
  const shareUrl = useQueryState<{ invite_code: string; share_url: string; direct_url: string }>('share');
  return {
    direct_url: shareUrl?.direct_url,
    invite_code: shareUrl?.invite_code,
    share_url: shareUrl?.share_url,
  };
}